import { verticalScreenSizes } from 'reduxState/screen/screenUtils';

export const ROW_HEIGHT = 26;

// Classes needed for some css highlighting to work inside of Row component
export const BIDS_WRAP_ID = 'orderbook-bids-id';

export const getOrderbookSideRowsCount = (verticalResolutionIndex: number) => {
  return verticalResolutionIndex >= verticalScreenSizes.largest
    ? 13
    : verticalResolutionIndex >= verticalScreenSizes.large
    ? 11
    : verticalResolutionIndex >= verticalScreenSizes.medium
    ? 10
    : 9; // small
};

const getOrderbookHeightPx = (verticalResolutionIndex: number) =>
  ROW_HEIGHT /* Middle row */ +
  21.5 /* Table header */ +
  2 * ROW_HEIGHT * getOrderbookSideRowsCount(verticalResolutionIndex);

export const getOrderbookSectionHeight = (verticalResolutionIndex: number) =>
  getOrderbookHeightPx(verticalResolutionIndex) + 40; /* Tabs height */
